import { alpha } from "@mui/system";

const styles = (theme) => ({
  container: {
    width: "100%",
    minHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0px",
    background: theme.palette.background.default,
  },
  formCard: {
    width: "100%",
    height: "100%",
    background: theme.palette.background.paper,
    borderRadius: "8px",
    boxShadow: theme.shadows[2],
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    width: "100%",
    padding: "24px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  content: {
    padding: "32px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  questionBox: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "16px",
    borderRadius: "8px",
    background: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
  },
  questionTitle: {
    fontWeight: 600,
    fontSize: "1rem",
    color: theme.palette.text.primary,
  },
  footer: {
    padding: "16px 24px",
    borderTop: `1px solid ${theme.palette.divider}`,
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    background: theme.palette.background.paper,
  },
  buttonSubmit: {
    borderRadius: "4px",
    padding: "8px 24px",
    fontWeight: 600,
    textTransform: "none",
  },
});

export default styles;
